module.exports = __webpack_public_path__ + "static/img/gl-1.51c8253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-1.jpg
// module id = HdSL
// module chunks = 0